export const IMAGE_NEW_REQUEST = 'IMAGE_NEW_REQUEST';
export const IMAGE_NEW_SUCCESS = 'IMAGE_NEW_SUCCESS';
export const IMAGE_NEW_FAIL = 'IMAGE_NEW_FAIL';
export const IMAGE_NEW_RESET = 'IMAGE_NEW_RESET';

export const IMAGE_ALL_REQUEST = 'IMAGE_ALL_REQUEST';
export const IMAGE_ALL_SUCCESS = 'IMAGE_ALL_SUCCESS';
export const IMAGE_ALL_FAIL = 'IMAGE_ALL_FAIL';

export const IMAGE_BY_ID_REQUEST = 'IMAGE_BY_ID_REQUEST';
export const IMAGE_BY_ID_SUCCESS = 'IMAGE_BY_ID_SUCCESS';
export const IMAGE_BY_ID_FAIL = 'IMAGE_BY_ID_FAIL';
export const IMAGE_BY_ID_RESET = 'IMAGE_BY_ID_RESET';

export const IMAGE_BY_EVENT_REQUEST = 'IMAGE_BY_EVENT_REQUEST';
export const IMAGE_BY_EVENT_SUCCESS = 'IMAGE_BY_EVENT_SUCCESS';
export const IMAGE_BY_EVENT_FAIL = 'IMAGE_BY_EVENT_FAIL';
export const IMAGE_BY_EVENT_RESET = 'IMAGE_BY_EVENT_RESET';

export const IMAGE_NAVBAR_REQUEST = 'IMAGE_NAVBAR_REQUEST';
export const IMAGE_NAVBAR_SUCCESS = 'IMAGE_NAVBAR_SUCCESS';
export const IMAGE_NAVBAR_FAIL = 'IMAGE_NAVBAR_FAIL';
export const IMAGE_NAVBAR_RESET = 'IMAGE_NAVBAR_RESET';

export const IMAGE_HOMESCREEN_REQUEST = 'IMAGE_HOMESCREEN_REQUEST';
export const IMAGE_HOMESCREEN_SUCCESS = 'IMAGE_HOMESCREEN_SUCCESS';
export const IMAGE_HOMESCREEN_FAIL = 'IMAGE_HOMESCREEN_FAIL';
export const IMAGE_HOMESCREEN_RESET = 'IMAGE_HOMESCREEN_RESET';

// export const IMAGE_UPDATE_BY_ID_REQUEST = 'IMAGE_UPDATE_BY_ID_REQUEST';
// export const IMAGE_UPDATE_BY_ID_SUCCESS = 'IMAGE_UPDATE_BY_ID_SUCCESS';
// export const IMAGE_UPDATE_BY_ID_FAIL = 'IMAGE_UPDATE_BY_ID_FAIL';
// export const IMAGE_UPDATE_BY_ID_RESET = 'IMAGE_UPDATE_BY_ID_RESET';

export const IMAGE_DELETE_REQUEST = 'IMAGE_DELETE_REQUEST';
export const IMAGE_DELETE_SUCCESS = 'IMAGE_DELETE_SUCCESS';
export const IMAGE_DELETE_FAIL = 'IMAGE_DELETE_FAIL';
export const IMAGE_DELETE_RESET = 'IMAGE_DELETE_RESET';
